import styled from 'styled-components';

export const STICKY_COLUMNS_WIDTH = '250px';
export const COLUMNS_WIDTH = '171px';

export const StyledTable = styled.table(({ theme }) => ({
  tableLayout: 'fixed',
  whiteSpace: 'nowrap',

  '& thead tr:first-child th': {
    background: theme.colors.bg,
    boxShadow: 'none',
  },

  'thead tr:not(:first-child) th:nth-child(n+3):after': {
    content: "''",
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '-1px',
    margin: 'auto',
    width: '1px',
    height: '50%',
    background: theme.colors.neutral[300],
  },
}));

export const StyledColgroup = styled.colgroup(() => ({
  'col:first-child': {
    width: STICKY_COLUMNS_WIDTH,
  },

  col: {
    width: COLUMNS_WIDTH,
  },
}));

interface FixedTableHeaderProps {
  position: number;
}

export const FixedTableHeader = styled.th<FixedTableHeaderProps>(({ theme, position }) => ({
  position: 'sticky',
  width: STICKY_COLUMNS_WIDTH,
  left: `calc(${STICKY_COLUMNS_WIDTH} * ${position})`,
  zIndex: 3,
  background: theme.colors.bg,

  '&:after': {
    content: "''",
    height: '100%',
    position: 'absolute',
    top: 0,
    width: '7px',
    boxShadow: '7px 0px 15px -15px inset rgba(55, 65, 81, 0.4)',
    right: '-7px',
  },
}));

export const TableHeader = styled.th<{ hasDivider?: boolean }>(({ theme, hasDivider }) => ({
  width: COLUMNS_WIDTH,
  background: theme.colors.bg,
  ...(hasDivider
    ? {
        '&:before': {
          content: "''",
          height: '100vh',
          position: 'absolute',
          top: 0,
          left: '-1px',
          width: '1px',
          background: theme.colors.neutral[300],
        },
      }
    : {}),
}));
